import R from 'ramda'

const MATCH_INTENT_TRIGGER_TYPE = 'MATCH_INTENT'
const MATCH_INTENT_DISPLAY_TYPE = 'Match Intent'

const isMatchIntentFormTrigger = R.propEq('type', MATCH_INTENT_DISPLAY_TYPE)

// The CTA post lives under data (an object), unlike the scalar-data triggers,
// because the evaluator reads trigger.data.ctaPost.
const convertMatchIntentFormTriggerToWidgetTrigger = R.applySpec({
  type: R.always(MATCH_INTENT_TRIGGER_TYPE),
  data: R.applySpec({ ctaPost: R.prop('ctaPost') }),
  operator: R.always('AND'),
  primary: R.T
})

export { isMatchIntentFormTrigger, convertMatchIntentFormTriggerToWidgetTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/twitter/form-to-widget/match-intent.js